import { render, staticRenderFns } from "./BottomReport.vue?vue&type=template&id=61b2900f"
import script from "./BottomReport.vue?vue&type=script&lang=js"
export * from "./BottomReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports